import { apiGet } from './client';

export async function fetchTaskEvents(taskSid, startDate = '2025-05-02', env) {
  if (!taskSid) throw new Error('taskSid is required');
  return apiGet(`/task-events/${taskSid}`, { params: { startDate, env } });
}
